import {
	PATH_ACTIVE_SINGLE_VOYAGES,
	PATH_ADMIN_ACCOUNTS,
	PATH_CAMERAS_LIST,
	PATH_DASHBOARD,
	PATH_EQUIPMENT,
	PATH_DEVICE_OPERATIONAL_STATISTIC,
	PATH_MONITORING_PLATFORM,
	PATH_REPORTS,
	PATH_TRACK_ADVANCED,
	PATH_VOYAGE_STADIUM,
} from '@constants/navigate'
import {IS_SEPARATED, TRACK_ORIGIN, TRACK_PATH} from "@constants/config";
import {INavigateItem} from "@view/navigate/types";

// The standalone build is not served by track, so legacy pages need the track host.
const TRACK_LINK = IS_SEPARATED ? `${TRACK_ORIGIN}${TRACK_PATH}` : TRACK_PATH

// Same items, order, urls and visibility as track: src/main/webapp/WEB-INF/velocity/block/main_nav.vm
export const NAVIGATE_LIST: INavigateItem[] = [
	{
		label: 'mapObject',
		path: `${TRACK_LINK}/map/object`,
		image: 'map',
	},
	{
		label: 'mapLabels.maps',
		path: PATH_TRACK_ADVANCED,
		image: 'mapV2',
		isNewFeatures: true,
		router: true,
	},
	{
		label: 'voyage',
		path: PATH_VOYAGE_STADIUM,
		image: 'voyage',
		router: true,
	},
	{
		label: 'journal',
		path: `${TRACK_LINK}/report/journal/`,
		image: 'report'
	},
	{
		label: 'singleVoyageMenu',
		path: PATH_ACTIVE_SINGLE_VOYAGES,
		image: 'singleVoyage',
		router: true,
		accessProps: ({account, getUserAccess}) => {
			return !!account?.hasSingleVoyage || getUserAccess({keys: 'ROLE_TENANT_ADMIN'})
		}
	},
	{
		label: 'voyageTable',
		path: `${TRACK_LINK}/voyageTable`,
		image: 'services'
	},
	{
		label: 'reportLabels.reports',
		path: PATH_REPORTS,
		image: 'reportV2',
		router: true,
		isNewFeatures: true
	},
	{
		label: 'base.statistic',
		path: PATH_DEVICE_OPERATIONAL_STATISTIC,
		image: 'statistic',
		router: true,
		isNewFeatures: true
	},
	{
		label: 'fuelInfo',
		path: `${TRACK_LINK}/fuel/info`,
		image: 'fuel'
	},
	{
		label: 'driversInfo',
		path: `${TRACK_LINK}/drivers/info`,
		image: 'drivers'
	},
	{
		label: 'base.equipmentNav',
		path: PATH_EQUIPMENT,
		image: 'equipment',
		router: true,
	},
	{
		label: 'accountInfo',
		path: `${TRACK_LINK}/account/info`,
		image: 'accountInfo'
	},
	{
		label: 'dashboard',
		path: PATH_DASHBOARD,
		image: 'window',
		router: true,
	},
	{
		label: 'accountAdmin',
		path: `${TRACK_LINK}/account`,
		image: 'system',
		accessProps: {
			keys: ['ROLE_ADMIN', 'ROLE_TENANT_ADMIN'],
		},
	},
	{
		label: 'adminAccounts.navigate',
		path: PATH_ADMIN_ACCOUNTS,
		image: 'system',
		router: true,
		isNewFeatures: true,
		accessProps: {
			keys: 'ROLE_TENANT_ADMIN',
		},
	},
	{
		label: 'base.cameras',
		path: PATH_CAMERAS_LIST,
		image: 'cameras',
		router: true,
		accessProps: {
			accessType: 'or',
			keys: ['ROLE_TENANT_ADMIN', 'acl.admin.camera.READ'],
		},
	},
	{
		label: 'base.monitoringPlatform',
		path: PATH_MONITORING_PLATFORM,
		image: 'monitoringPlatform',
		router: true,
		accessProps: {
			accessType: 'or',
			keys: ['ROLE_TENANT_ADMIN', 'acl.admin.camera.READ'],
		},
	},
	{
		label: 'help',
		path: `${TRACK_LINK}/help`,
		image: 'help'
	},
	{
		label: 'legalNotice',
		path: `${TRACK_LINK}/document/legal-notice`,
		image: 'docs'
	},
]
